// Must be the FIRST import: it installs the browser `process.env` shim, and
// ES module imports evaluate in source order. See polyfills.ts for why it
// moved out of angular.json's `polyfills` array (Story 78.1).
import './polyfills';
import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environments';
import { installHubPopstateGate } from './app/shared/hub/mobile/hub-popstate-gate';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.name,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: environment.sentryTracesSampleRate ?? 0,
  });
}

// Epic 88 Story 88.13 (notes C.22): the phone hubs' layer stack must hear `popstate` before the router does, and
// Chromium runs a window's listeners in registration order — so this capture listener is registered before Angular's.
installHubPopstateGate(window);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
